import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

/**
 * Returns true until the SSE stream has explicitly connected.
 * SSE-dependent actions should fail closed while the stream is absent,
 * connecting, reconnecting, or disconnected.
 */
export const useSSEUnavailable = (service: string) => {
  const stream = useSelector(
    (state: RootState) => state.sseSlice.streams?.[service],
  );

  return !stream?.isConnected;
};
